import { DeviceType } from '../../__generated__/graphql';
import type { DeviceStatusEvent, LastLocationAPI } from './definitions';

const createLastLocation = (lastLocationAPI: LastLocationAPI) => {
  const {
    heading,
    ignition_on: ignitionOn,
    latitude,
    longitude,
    speed,
    time_in_millis: timeInMillis,
    cobli_ingested_at: ingestionTimeInMillis,
    idle_on_duration_in_millis: idleOnDurationInMillis,
    idle_off_duration_in_millis: idleOffDurationInMillis,
    is_plugged: isPlugged,
    plugged_update_timestamp: pluggedUpdateTimestamp,
  } = lastLocationAPI;

  const lastLocation =
    Object.entries(lastLocationAPI).length > 0
      ? {
          heading,
          ignitionOn,
          speed,
          coordinate: { latitude, longitude },
          date: timeInMillis,
          ingestionTimeInMillis,
          ...(idleOnDurationInMillis && { idleOnDurationInMillis }),
          ...(idleOffDurationInMillis && { idleOffDurationInMillis }),
          ...(isPlugged !== undefined && { isPlugged }),
          ...(pluggedUpdateTimestamp && { pluggedUpdateTimestamp }),
        }
      : undefined;

  return lastLocation;
};

export const getDeviceType = (type?: string): DeviceType => {
  if (!type) {
    return DeviceType.Unknown;
  }
  const lowerType = type.toLowerCase();

  if (lowerType.includes('fmc150') && lowerType.includes('ibutton') && lowerType.includes('immobilizer')) {
    return DeviceType.CanIbuttonImmobillizer;
  }
  if (lowerType.includes('fmc150') && lowerType.includes('ibutton')) {
    return DeviceType.CanIbutton;
  }
  if (lowerType.includes('fmc150')) {
    return DeviceType.Can;
  }
  if (lowerType.includes('disabler')) {
    return DeviceType.Blocker;
  }
  if (lowerType.includes('ibutton') && lowerType.includes('immobilizer')) {
    return DeviceType.IButtonImmobilizer;
  }
  if (lowerType.includes('ibutton')) {
    return DeviceType.IButton;
  }
  if (lowerType.includes('immobilizer')) {
    return DeviceType.Immobilizer;
  }
  if (lowerType.includes('solar')) {
    return DeviceType.Solar;
  }
  if (lowerType.includes('fmb010') || lowerType.includes('plugandplay') || lowerType.includes('lmu3030')) {
    return DeviceType.ObdRemovable;
  }
  if (lowerType.includes('lmu') || lowerType.includes('fm')) {
    return DeviceType.Obd;
  }
  if (lowerType.includes('jc400')) {
    return DeviceType.Dashcam;
  }
  if (lowerType.includes('jc450') || lowerType.includes('jc451')) {
    return DeviceType.Multicam;
  }
  return DeviceType.Unknown;
};

export const deviceStatusEventTransformer = (lastLocationEventAPI: LastLocationAPI): DeviceStatusEvent => ({
  ...createLastLocation(lastLocationEventAPI)!,
  deviceId: lastLocationEventAPI.device_id,
});

export const deviceStatusEventsTransformer = (lastLocationEvents: LastLocationAPI[]) => lastLocationEvents.map(deviceStatusEventTransformer);
